import React, { useState } from "react";
import {
  TextField,
  MenuItem,
  Select,
  Box,
  FormHelperText,
  Chip,
} from "@mui/material";
import { Field, useField, useFormikContext } from "formik";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { useTheme } from "@mui/material/styles";

const FMultiSelect = ({ name, options, label, ...otherProps }) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);
  const { onBlur, value, ...newField } = field;

  const handleChange = (event) => {
    const { value } = event.target;
    setFieldValue(name, typeof value === "string" ? value.split(",") : value);
  };

  const configSelect = {
    ...newField,
    ...otherProps,
  };

  if (meta && meta.touched && meta.error) {
    configSelect.error = true;
    // configSelect.helperText = meta.error;
  }

  return (
    <FormControl {...configSelect} id="FormLabel" fullWidth>
      <InputLabel id="InputLabel">{label}</InputLabel>

      <Field
        id="SelectLabel"
        component={Select}
        multiple
        name={name}
        value={value}
        onChange={handleChange}
        input={<OutlinedInput value="hello" label={label} />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => (
              <Chip key={value} label={value.split(" ")[0]} />
            ))}
          </Box>
        )}
      >
        {options.map((item, pos) => {
          return (
            <MenuItem key={pos} value={item}>
              {item}
            </MenuItem>
          );
        })}
      </Field>
      <FormHelperText>{meta && meta.touched && meta.error}</FormHelperText>
    </FormControl>
  );
};

export default FMultiSelect;
